import { Injectable, computed, inject, signal } from '@angular/core';
import { WorkflowDraftConfirmationService } from '../workflow-registry-diagnostics/workflow-draft-confirmation.service';

/** Owns the alert-template buffer independently from workflow definitions. */
@Injectable({ providedIn: 'root' })
export class AlertTemplateDraftStateService {
  private readonly confirmation = inject(WorkflowDraftConfirmationService);
  readonly dirty = signal(false);
  readonly busy = signal(false);
  readonly isNavigationBlocked = computed(() => this.dirty() || this.busy());

  confirmNavigation(): boolean | Promise<boolean> {
    if (this.busy()) return false;
    if (!this.dirty()) return true;
    return this.confirmation.confirm({
      heading: 'Leave alert template edits?',
      message: 'Unsaved alert template changes will be lost.',
      confirmText: 'Leave without saving',
      cancelText: 'Stay on page',
    });
  }
}
